import { createContext, useContext } from 'react';

export type GetAccountToken = () => Promise<string | undefined>;

export const AccountAuthContext = createContext<GetAccountToken>(async () => undefined);
export const AccountAuthReadyContext = createContext(true);
export const AccountIdentityContext = createContext<string | undefined>(undefined);

export function useAccountToken(): GetAccountToken {
  return useContext(AccountAuthContext);
}

export function useAccountAuthReady(): boolean {
  return useContext(AccountAuthReadyContext);
}

export function useAccountIdentity(): string | undefined {
  return useContext(AccountIdentityContext);
}
